import React, { useEffect, useState } from 'react';
import logoimg from '../Images/logonew (1).png';
import { Link, NavLink } from 'react-router-dom';
import icon1 from '../Images/socialicon (1).png';
import icon2 from '../Images/socialicon (2).png';
import icon3 from '../Images/socialicon (3).png';
import icon4 from '../Images/socialicon (4).png';
import icon5 from '../Images/socialicon(5).png';
import axios from 'axios';
import config from '../../config/config';

const college = [
    { link: 'Delhi', rank: "Ranked 11 out of 80 TOI" },
    { link: 'Bangalore', rank: "Ranked 150 out of 1400S" },
    { link: 'Hyderabad', rank: "Ranked 609 out of 1400S" },
    { link: 'Mumbai', rank: "Ranked 95 out of 1400S" },
    { link: 'Chennai', rank: "Ranked 150 out of 1400S" },
    { link: 'Kolkata', rank: "Ranked 100 out of 1400S" },
];

const Footer = () => {
    const [navcourse, setNavcourse] = useState([]);
    const [study, setStudy] = useState([]);
    const [formData, setFormData] = useState({ email: '', phone: '', course: '' });
    const [errors, setErrors] = useState({ email: '', phone: '' });

    useEffect(() => {
        const fetchNavCourse = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_allNavCourse`);
                setNavcourse(response.data.allnavCourse || []);
            } catch (error) {
                console.error("Error fetching course data:", error);
            }
        };
        fetchNavCourse();
    }, []);

    useEffect(() => {
        const fetchStudyabroadData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_studyaborad`);
                setStudy(response.data.getAllStudyAborad || []);
            } catch (error) {
                console.error("Error fetching study abroad data:", error);
            }
        };
        fetchStudyabroadData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phone') {
            if (/^\d{0,10}$/.test(value)) {
                setFormData({ ...formData, phone: value });
                setErrors({ ...errors, phone: '' });
            } else {
                setErrors({ ...errors, phone: 'Only numbers are allowed' });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Please enter a valid email address";
        }
        if (!formData.phone || !/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Please enter a valid 10-digit phone number";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            const response = await axios.post(`${config.API_BASE_URL}/api/user/subscribe_data`, formData);
            if (response.status === 201 || response.status === 200) {
                alert("Subscribed successfully!");
                setFormData({ email: '', phone: '', course: '' });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    return (
        <footer className="bg-white">
            {/* Newsletter Section */}
            <section className="py-16 bg-blue-50 border-t border-gray-100">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-8">
                        <h4 className="text-2xl font-bold text-gray-800 mb-2">Subscribe to our newsletter</h4>
                        <p className="text-gray-600 text-sm">
                            Get College Notifications, Exam Notifications, and News Updates
                        </p>
                    </div>
                    <form onSubmit={handleSubmit} className="max-w-4xl mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div className="relative">
                                <input
                                    required
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter your Email"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-orange focus:border-transparent"
                                />
                                {errors.email && <span className="text-red-500 text-xs mt-1 block">{errors.email}</span>}
                            </div>

                            <div className="relative">
                                <input
                                    required
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Enter your Phone"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-orange focus:border-transparent"
                                />
                                {errors.phone && <span className="text-red-500 text-xs mt-1 block">{errors.phone}</span>}
                            </div>

                            <div>
                                <select
                                    required
                                    name="course"
                                    value={formData.course}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-orange focus:border-transparent bg-white"
                                >
                                    <option value="">Select Course</option>
                                    <option value="btech">BTech</option>
                                    <option value="mtech">MTech</option>
                                    <option value="mba">MBA</option>
                                    <option value="bca">BCA</option>
                                    <option value="msc">MSc</option>
                                    <option value="ma">MA</option>
                                    <option value="phd">PhD</option>
                                    <option value="bba">BBA</option>
                                    <option value="mca">MCA</option>
                                    <option value="bsc">BSc</option>
                                    <option value="ba">BA</option>
                                    <option value="bcom">BCom</option>
                                    <option value="mcom">MCom</option>
                                    <option value="bds">BDS</option>
                                    <option value="mbbs">MBBS</option>
                                    <option value="law">LLB</option>
                                    <option value="bfa">BFA</option>
                                    <option value="mfa">MFA</option>
                                </select>
                            </div>

                            <button className="bg-brand-orange text-white px-6 py-3 rounded-lg font-bold hover:bg-orange-700 transition">
                                Subscribe
                            </button>
                        </div>
                    </form>
                </div>
            </section>

            {/* Main Footer  */}
            <section className="py-16 bg-gray-900 text-gray-300">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

                        {/* Top Courses */}
                        <div>
                            <h4 className="text-white text-lg font-bold mb-4">Top Courses</h4>
                            <ul className="space-y-2">
                                {navcourse.length > 0 ? (
                                    navcourse.slice(0, 6).map((course, index) => (
                                        <li key={index}>
                                            <a href={`/Collegespage/${course._id}`} className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center">
                                                <i className="fa fa-angle-double-right mr-2"></i>
                                                {course.pageName}
                                            </a>
                                        </li>
                                    ))
                                ) : (
                                    <li className="text-gray-500 text-sm">No courses available</li>
                                )}
                            </ul>
                        </div>

                        {/* Top Universities */}
                        <div>
                            <h4 className="text-white text-lg font-bold mb-4">Top Universities</h4>
                            <ul className="space-y-2">
                                {college.map((item, index) => (
                                    <li key={index}>
                                        <NavLink to={`/TopStudy-colleges/${item.link}`} className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center">
                                            <i className="fa fa-angle-double-right mr-2"></i>
                                            College in {item.link}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Explore */}
                        <div>
                            <h4 className="text-white text-lg font-bold mb-4">Explore</h4>
                            <ul className="space-y-2">
                                <li><Link to="/TopUniversitiesandColleges" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>Top Universities</Link></li>
                                <li><Link to="/TopCourse" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>Top Courses</Link></li>
                                <li><Link to="/Exam" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>Exam</Link></li>
                                <li><Link to="/Scholarship" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>Scholarship</Link></li>
                                <li><Link to="/college-predictor" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>College Predictor</Link></li>
                                <li><Link to="/Admissionalert" className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center"><i className="fa fa-angle-double-right mr-2"></i>Admission Alert</Link></li>
                            </ul>
                        </div>

                        {/* Study Abroad */}
                        <div>
                            <h4 className="text-white text-lg font-bold mb-4">Study Abroad</h4>
                            <ul className="space-y-2">
                                {study.length > 0 ? (
                                    study.slice(0, 6).map((abroad, index) => (
                                        <li key={index}>
                                            <a href={`/Study-abroad/${abroad._id}`} className="text-gray-400 hover:text-brand-orange transition text-sm flex items-center">
                                                <i className="fa fa-angle-double-right mr-2"></i>
                                                {abroad.pageName}
                                            </a>
                                        </li>
                                    ))
                                ) : (
                                    <li className="text-gray-500 text-sm">No programs available</li>
                                )}
                            </ul>
                        </div>
                    </div>

                    {/* Other Links & Social */}
                    <div className="border-t border-gray-800 pt-8 mb-8">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
                            <div>
                                <p className="text-white font-semibold mb-3">Other Links</p>
                                <ul className="flex flex-wrap gap-4 text-sm">
                                    <li><Link to="/About" className="text-gray-400 hover:text-brand-orange transition">About Getfast Education</Link></li>
                                    <li><Link to="/contact" className="text-gray-400 hover:text-brand-orange transition">Contact Us</Link></li>
                                    <li><Link to="/terms&condition" className="text-gray-400 hover:text-brand-orange transition">Terms & Conditions</Link></li>
                                    <li><Link to="/Privacy-Policy" className="text-gray-400 hover:text-brand-orange transition">Privacy Policy</Link></li>
                                </ul>
                            </div>
                            <div className="flex justify-start lg:justify-end gap-4">
                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition">
                                    <img src={icon1} alt="LinkedIn" className="w-8 h-8" />
                                </a>
                                <a href="https://www.instagram.com/get_fasteducation/?hl=en" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition">
                                    <img src={icon2} alt="Instagram" className="w-8 h-8" />
                                </a>
                                <a href="https://www.facebook.com/getfasteducation" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition">
                                    <img src={icon3} alt="Facebook" className="w-8 h-8" />
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition">
                                    <img src={icon4} alt="Twitter" className="w-8 h-8" />
                                </a>
                                <a href="https://www.youtube.com/@GetFastEducation" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition">
                                    <img src={icon5} alt="YouTube" className="w-8 h-8" />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Disclaimer */}
                    <div className="border-t border-gray-800 pt-8 mb-8">
                        <h4 className="text-white font-bold mb-3">Disclaimer</h4>
                        <p className="text-gray-500 text-xs leading-relaxed">
                            Getfast Education provides educational information, resources, and university details for informational purposes only. While we strive to ensure the accuracy and reliability of the content on our platform, we do not guarantee its completeness, timeliness, or accuracy. Users are advised to verify all details directly with official university websites before making any decisions. Our website may include links to third-party websites, including universities, educational institutions, and external resources. These links are provided for convenience and informational purposes only. Getfast Education does not control, endorse, or take responsibility for the content, privacy policies, or practices of any third-party websites.
                        </p>
                    </div>

                    {/* Copyright */}
                    <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                            <Link to="/">
                                <img src={logoimg} alt="Get Fast Education Logo" className="h-8" />
                            </Link>
                            <span className="text-gray-500 text-sm">© 2025 Get Fast Education, Inc. All Rights Reserved.</span>
                        </div>
                    </div>
                </div>
            </section>
        </footer>
    );
};

export default Footer;
